// Blank copy drops out (D4).
//
// A staff-editable copy block published EMPTY — "" or whitespace only — means
// "show nothing here", so a surface rendering server copy drops the element that
// would hold it AND any framing that exists only for it (a divider, a separator
// dot, an accent rule, a label's required asterisk). A published "" is a value,
// not "no override": the resolver hands it through untouched, so the check has to
// live where the text is rendered. `??` does not catch "", hence trim().
//
// Functional controls never drop with their label: a checkbox, chip, button or
// input stays and keeps working; only its empty text element goes.

/** True when a copy block has something to show. */
export function hasText(text: string | null | undefined): text is string {
  return typeof text === "string" && text.trim() !== "";
}

/** The block itself, or `undefined` when it is blank — for props whose consumer
 *  already omits its element on a falsy value (`FormField`'s `label` and
 *  `helperText`, an `aria-label`), which a whitespace-only string would pass. */
export function textOrUndefined(text: string | null | undefined): string | undefined {
  return hasText(text) ? text : undefined;
}
